import React from "react";
import { View, StyleSheet } from "react-native";
import BaseAdminController from "./BaseAdminController";
import NtText from "../../components/NtText";
import NtSectionButton from "../../marketing/components/general/NtSectionButton";
import Logger from "../../common/utils/Logger";
import AdminNavigator from "../../navigation/AdminNavigator";

class AdminController extends BaseAdminController {
  state = {
    ...super.state,
  };

  componentDidMount() {
    Logger("------------------- inside of admin", this.props.route);
  }
  render() {
    return (
      <View style={styles.container}>
        <NtText>Admin here</NtText>

        <NtSectionButton
          title="click me"
          onPress={() => {
            // this.props.navigation.navigate("admin", {
            //   screen: "did",
            //   params: {
            //     token: "screen E",
            //   },
            // });
            this.props.navigation.navigate("did", {
              token2: "34343443434",
            });
          }}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    padding: 0,
    flex: 1,
  },
});

export default AdminController;
